import { inject} from '@angular/core';
import {
  HttpErrorResponse,
  HttpInterceptorFn
} from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiErrorHandlerFactory } from './handlers/api-error-handler-factory';

export const ApiErrorInterceptor: HttpInterceptorFn = (request, next) => {
  const apiErrorHandlerFactory = inject(ApiErrorHandlerFactory);
  const apiErrorHandler = apiErrorHandlerFactory.getApiErrorHandler(request);
  request = apiErrorHandler.prepareRequest(request);
  return next(request).pipe(
    catchError((apiError: HttpErrorResponse) => {
      apiErrorHandler.handleError(apiError);
      return throwError(apiError);
    })
  );
}